import { ApolloClient, NormalizedCacheObject, useLazyQuery, useMutation } from '@apollo/client';
import {
  EditCourseLessonsData,
  EditCourseLessonsVars,
  LessonData,
  LessonVars,
  SaveLessonData,
  SaveLessonVars
} from '../gql-types';

import ApolloClientService from '../../shared/services/ApolloClientService';
import Config from '../../shared/config';
import ContentGraphQL from '../gql';

let contentApolloClient: ApolloClient<NormalizedCacheObject> = null;

function useLessons() {
  if (!contentApolloClient) {
    contentApolloClient = ApolloClientService.create(Config.CONTENT_GQL);
  }

  const [
    getEditLessonsList,
    { loading: loadingLessons, error: loadLessonsError, data: lessonsList }
  ] = useLazyQuery<EditCourseLessonsData, EditCourseLessonsVars>(
    ContentGraphQL.Query.COURSE_EDIT_LESSONS_LIST,
    {
      client: contentApolloClient
    }
  );

  const [
    _getLesson,
    { loading: loadingLesson, error: loadLessonError, data: lessonData }
  ] = useLazyQuery<LessonData, LessonVars>(ContentGraphQL.Query.LESSON, {
    client: contentApolloClient,
    fetchPolicy: 'cache-and-network'
  });

  function getLesson(lessonkey: number) {
    _getLesson({
      variables: {
        lessonkey
      }
    });
  }

  const [saveLesson, { loading: saving, error: saveError, data: saveData }] =
    useMutation<SaveLessonData, SaveLessonVars>(
      ContentGraphQL.Mutation.SAVE_LESSON,
      {
        client: contentApolloClient
      }
    );

  return {
    getLesson,
    loadingLesson,
    loadLessonError,
    lesson: lessonData?.lesson,
    saveLesson,
    savingLesson: saving,
    saveLessonError: saveError,
    savedLesson: saveData?.saveLesson,
    getEditLessonsList,
    loadingLessons,
    editCourseLessonsData: lessonsList?.courseEditLessonsList
  };
}

export default useLessons;
